export default [{
    path: '/coin',
    component: () => import('@/views/coin/index')
}]